import React, { useState, useEffect } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import styles from '../../styles/forms/edit_my_company_member_employment_general_group_wizard/EditMyCompanyMemberEmploymentGeneralGroupForm.scss';
import Button from '../../components/Button';
import { __, setTableParams } from '../../core/utils';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import Select from '../../components/Select';
import * as _ from 'lodash';
import Input from '../../components/Input';
import { connect } from 'react-redux';
import { map } from 'lodash';
import DateTimePicker from '../../components/DateTimePicker';
import { listPossibleWorkSites } from '../../redux/actions/table/timesheets';
import { listCompanySegments } from '../../redux/actions/table/company_segments';
import { listCompanyPositions } from '../../redux/actions/table/company_positions';

const EditMyCompanyMemberEmploymentGeneralFutureGroupForm = ({
  handleSubmit,
  submitting,
  localization,
}) => {
  const [possibleOffices, setPossibleOffices] = useState([]);
  const [possibleSegments, setPossibleSegments] = useState([]);
  const [possiblePositions, setPossiblePositions] = useState([]);

  useEffect(() => {
    listPossibleWorkSites().then(({ response }) => {
      setPossibleOffices(response.data);
    });

    listCompanySegments().then(({ response }) => {
      setPossibleSegments(
        response.data.map((item) => ({
          value: item.id,
          label: item.name,
        }))
      );
    });

    listCompanyPositions().then(({ response }) => {
      setPossiblePositions(
        response.data.map((item) => ({
          value: item.id,
          label: item.name,
        }))
      );
    });
  }, []);

  const workplaces = [
    { label: __('home'), value: 'home' },
    { label: __('office'), value: 'office' },
    { label: __('partial'), value: 'partial' },
  ];

  const type_of_employments = [
    { label: __('employee'), value: 'employee' },
    { label: __('external'), value: 'external' },
  ];

  const logs_time_options = [
    { value: 'true', label: __('Yes') },
    { value: 'false', label: __('No') },
  ];

  return (
    <Form onSubmit={handleSubmit} className={styles.wrapper}>
      <div className={styles.form}>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='address_book_company_id'
              searchable={true}
              component={Select}
              label={__('my_company_members.flyout.office')}
              options={map(possibleOffices, (office) => ({
                value: office.id,
                label: office.name,
              }))}
              // callbackSetNewValue={(value) => {
              //   createNewWorksite(value);
              // }}
              placeholder={__('my_company_members.flyout.select-office')}
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='company_segment_id'
              searchable={true}
              component={Select}
              label={__('table.columns.office_segment')}
              options={possibleSegments}
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='work_place'
              component={Select}
              searchable={true}
              label={__('table.columns.workplace')}
              options={workplaces}
            />
          </div>
        </div>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='company_position_id'
              searchable={true}
              component={Select}
              label={__('table.columns.office_position')}
              options={possiblePositions}
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='type'
              component={Select}
              searchable={true}
              label={__('table.columns.type_of_employment')}
              options={type_of_employments}
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='logs_time'
              component={Select}
              searchable={true}
              label={__('table.columns.logs_time')}
              options={logs_time_options}
            />
          </div>
        </div>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='prior_work_experience'
              component={Input}
              label={__('my_company_members.flyout.prior_work_experience')}
              placeholder='YY-MM-DD'
              numeric
              options={{
                delimiter: '-',
                blocks: [2, 2, 2],
                numericOnly: true,
              }}
              hint={'YY-MM-DD'}
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='company_employment_date'
              component={Input}
              label={__('my_company_members.flyout.company_employment_date')}
              placeholder='DD.MM.YYYY'
              numeric
              options={{
                delimiter: '.',
                blocks: [2, 2, 4],
                numericOnly: true,
              }}
              hint={'DD.MM.YYYY'}
            />
          </div>
          <div className={styles.f1}></div>
        </div>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='general_start_date'
              component={DateTimePicker}
              label={__('my_company_members.flyout.general_start_date')}
              footer
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='general_end_date'
              component={DateTimePicker}
              label={__('my_company_members.flyout.general_end_date')}
              footer
            />
          </div>
          <div className={styles.f1}></div>
        </div>
      </div>

      <div className={styles.footer}>
        <Button
          lightGray
          medium
          left
          middleText={__('button.cancel')}
          onClick={() =>
            setTableParams('my_company_members', {
              edit_my_company_member_employment_general_group_wizard: undefined,
            })
          }
        />
        <Button
          lightBlue
          medium
          right
          submit
          middleText={__('button.edit')}
          spinning={submitting}
        />
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    store: _.get(state.table, 'my_company_members'),
  };
};

export default withRouter(
  reduxForm({
    form: 'edit_my_company_member_employment_general_group_wizard.edit_my_company_member_employment_general_future_group',
  })(
    connect(
      mapStateToProps,
      null
    )(
      subscribe(
        Localization,
        'localization'
      )(EditMyCompanyMemberEmploymentGeneralFutureGroupForm)
    )
  )
);
